import { instance } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';

const baseURL = `${getAPIHost()}/v1/capstone/psaps`;

const linkType = '?link_type=agency_share_chat';

export const getAgencyLinks = async org =>
  instance.get(`${baseURL}/${org}/agency-link${linkType}`, {
    headers: { retry: true },
  });

export const getAgencies = data => {
  let url = `${baseURL}/${data.org}/agency-link/authorities${linkType}`;
  return instance.get(url, { headers: { retry: true } });
};

export const postAgency = data =>
  instance.post(`${baseURL}/${data.org}/agency-link${linkType}`, data, {
    headers: { retry: true },
  });

export const patchAgency = data =>
  instance.patch(
    `${baseURL}/${data.org}/agency-link/${data.id}`,
    {
      status: data.status,
    },
    { headers: { retry: true } },
  );

export const deleteAgency = data =>
  instance.delete(`${baseURL}/${data.org}/agency-link/${data.id}`, {
    headers: { retry: true },
  });
